import React, { useEffect, useState } from 'react';
import './NavbarButton.css';
import InputSerach from '../InputSerach/InputSearchs';
import Favoritos from '../Favoritos/Favoritos';
import baseURL from '../url';
import { Link as Anchor } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faShare } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebookF, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function NavbarButton() {
    const [tienda, setTienda] = useState({});
    const [openSocials, setOpenSocials] = useState(false);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda?.reverse()[0] || {});
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const abrirMapa = () => {
        const dir = encodeURIComponent(tienda.direccion || 'Argentina');
        window.open(`https://www.google.com/maps/search/?api=1&query=${dir}`, "_blank");
    };

    const compartirPagina = () => {
        if (navigator.share) {
            navigator.share({
                title: tienda.nombre || 'Sistema de Servicios',
                url: window.location.href,
            }).catch(err => console.log('Error al compartir:', err));
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('¡Enlace copiado al portapapeles!');
        }
    };

    return (
        <div className='NavbarButtonContent'>

            {/* MODAL DE PERFIL QUE SE DESPLIEGA CON EL BOTÓN + */}
            <div className={`Modalsocials ${openSocials ? 'active' : ''}`}>
                
                {/* PORTADA Y LOGO ESTÁTICOS */}
                <div className="socialsCover">
                    <img src="/portada.jpg" alt="Portada" />
                    <div className="socialsAvatar">
                        <img src="/logo.jpg" alt="Logo" />
                    </div>
                </div>

                {/* CONTENIDO DE LA TARJETA */}
                <div className="socialsBody">
                    <h3 className="socialsTitle">{tienda.nombre || 'Sistema de Servicios'}</h3>
                    <p className="socialsSubtitle">{tienda.eslogan || 'Nuevo eslogan administrable'}</p>

                    {/* UBICACIÓN Y EMAIL */}
                    <div className="infoList">
                        <div className="infoItem" onClick={abrirMapa}>
                            <FontAwesomeIcon icon={faMapMarkerAlt} className="infoIcon" />
                            <span>{tienda.direccion || 'Argentina'}</span>
                        </div>

                        <Anchor to={`mailto:${tienda.email || 'sistema@gmail.com'}`} target="_blank" className="infoItem">
                            <FontAwesomeIcon icon={faEnvelope} className="infoIcon" />
                            <span>{tienda.email || 'sistema@gmail.com'}</span>
                        </Anchor>
                    </div>

                    {/* BOTONES REDES SOCIALES */}
                    <div className="socialButtons">
                        <a href={tienda.instagram || '#'} target="_blank" rel="noopener noreferrer" className="socialBtn">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a href={tienda.facebook || '#'} target="_blank" rel="noopener noreferrer" className="socialBtn">
                            <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                        <Anchor to={`https://wa.me/${tienda.telefono}`} target="_blank" className="socialBtn whatsapp">
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </Anchor>
                    </div>

                    {/* BOTÓN COMPARTIR */}
                    <button className="btnShare" onClick={compartirPagina}>
                        Compartir en.. <FontAwesomeIcon icon={faShare} />
                    </button>
                </div>

            </div>

            {/* BARRA INFERIOR ORIGINAL */}
            <div className='NavbarButton'>
                <InputSerach />

                <button
                    className={`plusButton ${openSocials ? 'open' : ''}`}
                    onClick={() => setOpenSocials(!openSocials)}
                >
                    +
                </button>

                <Favoritos />
            </div>
        </div>
    );
}